// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1QR4i","requiredAsterisk":"Info_requiredAsterisk__2r2x0"};